export const normalizeSearchQuery = (query) => String(query ?? "").trim();

const charactersMatch = (left, right) =>
	left.toLowerCase() === right.toLowerCase();

export const mergeHighlightRanges = (ranges) => {
	if (!Array.isArray(ranges)) return [];

	const normalizedRanges = [];
	for (const range of ranges) {
		if (!Array.isArray(range) || range.length < 2) continue;

		const start = Number(range[0]);
		const end = Number(range[1]);
		if (!Number.isFinite(start) || !Number.isFinite(end)) continue;

		const normalizedStart = Math.max(0, Math.trunc(start));
		const normalizedEnd = Math.max(0, Math.trunc(end));
		if (normalizedEnd <= normalizedStart) continue;

		normalizedRanges.push([normalizedStart, normalizedEnd]);
	}

	normalizedRanges.sort(
		(left, right) => left[0] - right[0] || left[1] - right[1],
	);

	const mergedRanges = [];
	for (const range of normalizedRanges) {
		const previous = mergedRanges[mergedRanges.length - 1];
		if (previous && range[0] <= previous[1]) {
			previous[1] = Math.max(previous[1], range[1]);
			continue;
		}

		mergedRanges.push(range);
	}

	return mergedRanges;
};

export const fuzzyMatchText = (text, query) => {
	const source = String(text ?? "");
	const normalizedQuery = normalizeSearchQuery(query);

	if (!normalizedQuery) {
		return { matched: true, ranges: [] };
	}

	const ranges = [];
	let sourceIndex = 0;
	let rangeStart = -1;
	let previousMatchIndex = -1;

	for (
		let queryIndex = 0;
		queryIndex < normalizedQuery.length;
		queryIndex += 1
	) {
		const queryCharacter = normalizedQuery[queryIndex];
		let matchIndex = -1;

		while (sourceIndex < source.length) {
			if (charactersMatch(source[sourceIndex], queryCharacter)) {
				matchIndex = sourceIndex;
				sourceIndex += 1;
				break;
			}
			sourceIndex += 1;
		}

		if (matchIndex === -1) {
			return { matched: false, ranges: [] };
		}

		if (rangeStart === -1) {
			rangeStart = matchIndex;
		} else if (matchIndex !== previousMatchIndex + 1) {
			ranges.push([rangeStart, previousMatchIndex + 1]);
			rangeStart = matchIndex;
		}

		previousMatchIndex = matchIndex;
	}

	ranges.push([rangeStart, previousMatchIndex + 1]);

	return { matched: true, ranges };
};

export const fuzzyMatchFields = (fields, query) => {
	const normalizedQuery = normalizeSearchQuery(query);
	if (!normalizedQuery) return true;
	if (!Array.isArray(fields)) return false;

	return fields.some((field) => fuzzyMatchText(field, normalizedQuery).matched);
};
